export default __webpack_public_path__ + "media/design-system/icon/assets/brand/MD/downside-7cda806f083cf0127ec41744187b1e31.svg";